/**
 * Lê variável CSS declarada em :root (útil para SweetAlert e libs que exigem cor resolvida).
 */
export function rootCssVar(name) {
  if (typeof document === 'undefined') {
    return ''
  }
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim()
}
